export const featuredPortfolio = [
  {
    id: 1,
    title: "Disease Detection in Gastro-Intestinal using Transfer Learning",
    img:
      "assets/gtract.png",
    link: "https://www.kaggle.com/vasanthkumar14/final-year-project-gastrointestinal"
  },
  {
    id: 4,
    title: "Prevail - Flutter Application",
    img:
      "assets/prevail.jpg",
    link: "https://github.com/VasanthKumar14/PREVAIL-APP"
  },
  {
    id: 5,
    title: "Plant Disease Diagnose",
    img:
      "assets/plant.png",
    link: "https://github.com/VasanthKumar14/MINI-PROJECT-3rd-Year-"
  },
];
